import { SAVE_RESPONSE, SET_STATE } from './type';
import {
  IS_SUBMIT_INPROGRESS,
  IS_SURVEY_SUBMITTED,
  SHOW_FAILURE_NOTIFICATION,
  SHOW_SUCCESS_NOTIFICATION,
} from '../ui/type';
import { getTransCustomerFeedbackAggreatorServiceClient } from '../../clients/TransCustomerFeedbackAggreatorServiceClient';
import getFeedbackResponseInitialState from '../../utils/getFeedbackResponseInitialState';
import { CSAT_SURVEY_FEEDBACKINTENT } from '../../constants/FeedbackConstants';

/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").UserFeedback} UserFeedback */
/** @typedef {{type: string, payload: any}} Action */

export function saveResponse({ id, answer }) {
  return {
    type: SAVE_RESPONSE,
    payload: {
      id,
      answer,
    },
  };
}

/**
 * Init response from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questions
 * @returns {Action}
 */
export function initializeResponse(questions) {
  return {
    type: SET_STATE,
    payload: getFeedbackResponseInitialState(questions),
  };
}

/**
 * Submit response action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @param {UserFeedback} userFeedback
 * @returns {(dispatch: Function) => Promise<Action>}
 */
export function submitResponse(
  applicationId,
  feedbackIntent,
  userFeedback,
  sifProfileId
) {
  return (dispatch) => {
    const submitFeedbackRequest = {
      applicationId,
      feedbackIntent,
      userFeedback,
      sifProfileId,
    };
    dispatch({ type: IS_SUBMIT_INPROGRESS, payload: true });
    const client = getTransCustomerFeedbackAggreatorServiceClient();
    return client
      .submitFeedback(submitFeedbackRequest)
      .toPromise()
      .then(() => {
        if (feedbackIntent.includes(CSAT_SURVEY_FEEDBACKINTENT)) {
          dispatch({
            type: IS_SURVEY_SUBMITTED,
            payload: true,
          });
        }
        dispatch({
          type: SHOW_SUCCESS_NOTIFICATION,
        });
        dispatch({
          type: IS_SUBMIT_INPROGRESS,
          payload: false,
        });
      })
      .catch(() => {
        dispatch({
          type: IS_SUBMIT_INPROGRESS,
          payload: false,
        });
        dispatch({
          type: SHOW_FAILURE_NOTIFICATION,
        });
      });
  };
}
